import { NestedHome } from '@habity/types';
import { HomeDataBuilder } from './data-builder';
import { balconyPatioFields } from './balconyPatio-fields';

export const getBalconyPatioData = (home: NestedHome) => {
  if (!home?.provider_data || !home?.provider_type) return [];

  return new HomeDataBuilder(home).addFields(balconyPatioFields).build();
};
